import "./PasswordStrengthCheckerComponent.scss";
import ChipComponent from "../chip/ChipComponent";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useEffect} from "react";

interface PasswordStrengthCheckerComponentProps {
    password?: string;
    isPasswordValid: Function;
}

const validatorOptions = [
    {
        label: '8 or more characters',
        validator: (value: string) => {
            return value.length >= 8;
        }
    },
    {
        label: '1 symbol',
        validator: (value: string) => {
            return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
        }
    },
    {
        label: '1 number',
        validator: (value: string) => {
            return /[0-9]/.test(value);
        }
    },
    {
        label: '1 uppercase letter',
        validator: (value: string) => {
            return /[A-Z]/.test(value);
        }
    },
    {
        label: '1 lowercase letter',
        validator: (value: string) => {
            return /[a-z]/.test(value);
        }
    }
]
const PasswordStrengthCheckerComponent = (props: PasswordStrengthCheckerComponentProps) => {
    const {password, isPasswordValid} = props;

    useEffect(() => {
        if (password) {
            isPasswordValid(validatorOptions.every((option) => {
                return option.validator(password);
            }))
        }
    }, [password,isPasswordValid])

    return (
        <div className={'password-validator-component'}>
            {
                validatorOptions.map((option, index) => {
                    return (
                        <ChipComponent
                            prefixIcon={password ? option.validator(password) ? <CheckCircleOutlineIcon color={'error'}/> :
                                <CancelOutlinedIcon color={"error"}/> : <></>} label={option.label}
                            key={index}
                            className={password ? option.validator(password) ? 'completed' : 'rejected' : ''}
                        />
                    )
                })
            }
        </div>
    );

};

export default PasswordStrengthCheckerComponent;
